import {lazy, Suspense} from 'react';
import { useState, useEffect } from 'react';
import  { Routes, Route } from "react-router-dom";

import Spinner from "../spinner/Spinner"

const Home = lazy(() => import("../pages/HomePage"));
const OurCoffee = lazy(() => import("../pages/OurCoffeePage"));
const ContactUs = lazy(() => import("../pages/ContactUsPage"));
const SingleCoffeePage = lazy(() => import("../pages/SingleCoffeePage"));
const Page404 = lazy(() => import("../pages/Page404"));

const App = () => {
  const [flag, setFlag] = useState(false);

    useEffect(() => {
      window.addEventListener('resize', resizeHandler);
    });

    const resizeHandler = () => {
      let timerID;

      if (!flag) {
        document.querySelector("html").classList.add("resize-active");

        setFlag(true);
        clearTimeout(timerID);
        timerID = setTimeout(removeClassHandler, 500);
      }
    }

    const removeClassHandler = () => {
      document.querySelector("html").classList.remove("resize-active");
      setFlag(false);
    }

    return (
      <Suspense fallback={<Spinner/>}>
          <Routes>
              <Route path="/" element={<Home/>}/>
              <Route path="/our-coffee" element={<OurCoffee/>}/>
              <Route path="/contact-us" element={<ContactUs/>}/>
              <Route path="/our-coffee/:id" element={<SingleCoffeePage/>}/>
              <Route path="*" element={<Page404/>}/>
          </Routes>
      </Suspense>
  )
}

export default App;